export default __webpack_public_path__ + "static/media/chevron.bbfc6619.svg";